var _linearGradient, _linearGradient2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg3314620(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 512.008 512.008",
    height: 512,
    viewBox: "0 0 512.008 512.008",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.004,
    x2: 256.004,
    y1: 497.005,
    y2: 0.002
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fd3a84"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa68d"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 256.003,
    x2: 256.003,
    y1: 512.005,
    y2: 482.005
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc2cc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff2f4"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m226.003 240.005h-60c-8.284 0-15 6.716-15 15v242h90v-242c0-8.284-6.715-15-15-15zm120 60h-60c-8.284 0-15 6.716-15 15v182h90v-182c0-8.284-6.715-15-15-15zm-240-120h-60c-8.284 0-15 6.716-15 15v302h90v-302c0-8.284-6.715-15-15-15zm360 180h-60c-8.284 0-15 6.716-15 15v122h90v-122c0-8.284-6.715-15-15-15zm45.105-110.633-29.638-81.901c-2.819-7.79-11.419-11.821-19.209-9.001-7.79 2.819-11.82 11.419-9.001 19.209l16.899 46.7-448.482-222.807c-7.42-3.685-16.422-.659-20.107 6.759-3.686 7.419-.659 16.421 6.76 20.107l448.254 222.693-47.264 14.429c-7.923 2.418-12.386 10.802-9.967 18.726 2.431 7.964 10.843 12.375 18.726 9.967l83.304-25.43c8.21-2.507 12.644-11.386 9.725-19.451z",
    fill: "url(#SVGID_1_)"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m497.003 482.005h-482c-8.284 0-15 6.716-15 15s6.716 15 15 15h482c8.284 0 15-6.716 15-15s-6.715-15-15-15z",
    fill: "url(#SVGID_2_)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg3314620);
export default __webpack_public_path__ + "static/media/3314620.1652071fb2d43b773fe5109349f09887.svg";
export { ForwardRef as ReactComponent };